import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from '@app/App';
import { initializeSentry } from '@utils/sentryInitialization';
import reportWebVitals from './reportWebVitals';

initializeSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));

// strict mode double renders the env leading to double logs for dev errors,
// its kind of annoying with little value unless you are actively debugging
// a complex state error
const ENABLE_STRICT_MODE = false;

let Entry;
if (ENABLE_STRICT_MODE) {
  Entry = (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  Entry = <App />;
}
root.render(Entry);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
